import { UploadOutlined } from '@ant-design/icons';
import { Avatar, Button, Card } from 'antd';
import { observer } from 'mobx-react';
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { accountStore } from 'store/accountStore';
import './FileUploadCard.css';

const { Meta } = Card;

const FileUploadCard: React.FC<{ platformId: number }> = ({ platformId }) => {
  const navigate = useNavigate();
  // LG Channel Vietnam 전용 계정만 VN 업로드 화면으로. (/assets/add 자체도 같은 규칙으로
  // 리다이렉트하므로 여기는 한 번의 이동을 아끼는 UX 최적화일 뿐이다.)
  const directUploadPath = accountStore.isLgChannelVietnam() ? '/assets/add-vn' : '/assets/add';
  return (
    <div>
      <Card hoverable className="custom-card" style={{ width: '100%', marginBottom: '16px' }}>
        <div className="card-content">
          <Meta
            avatar={
              <Avatar
                size={48}
                style={{ backgroundColor: '#f6f6f6' }}
                icon={<UploadOutlined style={{ color: 'black' }} />}
              />
            }
            title={<span className="upload-description">{'Upload Video'}</span>}
          />
          <div className="buttons-container">
            {
              <>
                <Button onClick={() => navigate(directUploadPath)}>Direct Upload</Button>
                {platformId === 1 && (
                  <Button onClick={() => navigate('/assets-source')}>SFTP Upload</Button>
                )}
                {/* <Button onClick={() => navigate('/assets')}>Manage Video</Button> */}
              </>
            }
          </div>
        </div>
      </Card>
    </div>
  );
};

export default observer(FileUploadCard);
